/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {FolderResource} from '../../components/api/resources/resource/folder.resource';

@Component({
  standalone: false,
  selector: 'adn-folder-route-page',
  template: `
    <adn-folder-list-page
      *ngIf="list"
      [list]="list">
    </adn-folder-list-page>
  `
})
export class FolderRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(FolderResource) private readonly Folder: any
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.Folder, false, 'fullFolderList', {
      baseTable: 'folder'
    });
  }
}
